import React from "react";

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.55)",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px",
  },
  card: {
    background: "#fff",
    borderRadius: "20px",
    width: "100%",
    maxWidth: "480px",
    boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
    overflow: "hidden",
    fontFamily: "'CastaBold', sans-serif",
    position: "relative",
  },
  topBar: {
    background: "linear-gradient(135deg, #FF4E00 0%, #ff7a3d 100%)",
    padding: "28px 24px 22px",
    textAlign: "center",
    position: "relative",
  },
  badge: {
    display: "inline-block",
    background: "rgba(255,255,255,0.22)",
    color: "#fff",
    fontSize: "11px",
    fontWeight: 700,
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    borderRadius: "20px",
    padding: "4px 12px",
    marginBottom: "10px",
  },
  emoji: {
    fontSize: "38px",
    display: "block",
    marginBottom: "6px",
    lineHeight: 1,
  },
  title: {
    color: "#fff",
    fontFamily: "'CastaExtraBold', sans-serif",
    fontSize: "22px",
    lineHeight: 1.2,
    margin: 0,
  },
  closeBtn: {
    position: "absolute",
    top: "14px",
    right: "16px",
    background: "rgba(255,255,255,0.2)",
    border: "none",
    borderRadius: "50%",
    width: "30px",
    height: "30px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontSize: "16px",
    lineHeight: 1,
    padding: 0,
    transition: "background 0.2s",
  },
  body: {
    padding: "24px 28px",
  },
  greeting: {
    color: "#222",
    fontSize: "15px",
    lineHeight: "1.65",
    margin: "0 0 14px",
  },
  highlight: {
    fontFamily: "'CastaExtraBold', sans-serif",
    color: "#FF4E00",
  },
  divider: {
    border: "none",
    borderTop: "1px solid #f0f0f0",
    margin: "14px 0",
  },
  note: {
    color: "#666",
    fontSize: "13.5px",
    lineHeight: "1.6",
    margin: 0,
  },
  footer: {
    padding: "0 28px 24px",
    textAlign: "center",
  },
  button: {
    background: "#FF4E00",
    color: "#fff",
    border: "none",
    borderRadius: "12px",
    padding: "13px 40px",
    fontSize: "15px",
    fontFamily: "'CastaExtraBold', sans-serif",
    cursor: "pointer",
    transition: "background 0.2s, transform 0.15s",
    display: "inline-block",
  },
};

const HostFreeNoticeModal = ({ firstName, onClose }) => {
  const name = firstName ? firstName : "";

  return (
    <div style={styles.overlay} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div style={styles.card}>
        {/* Banda superior naranja */}
        <div style={styles.topBar}>
          <button
            style={styles.closeBtn}
            onClick={onClose}
            onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.35)")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.2)")}
            aria-label="Cerrar"
          >
            ✕
          </button>
          <span style={styles.badge}>🔔 Novedad</span>
          <h2 style={styles.title}>¡Alohar ahora es 100% gratis!</h2>
        </div>

        {/* Cuerpo */}
        <div style={styles.body}>
          <p style={styles.greeting}>
            {name ? (
              <>
                Hola <span style={styles.highlight}>{name}</span>,{" "}
              </>
            ) : (
              "¡Hola! "
            )}
            desde Alohar queríamos avisarte que{" "}
            <span style={styles.highlight}>a partir del 14 de Marzo</span>,
            Alohar será <strong>100% gratis</strong> y ya no será intermediario
            en las reservas de tus huéspedes. Tus futuros huéspedes te
            contactarán en forma directa al{" "}
            <strong>WhatsApp que tengas configurado</strong> en tu cuenta.
          </p>

          <hr style={styles.divider} />

          <p style={styles.note}>
            ✅ Si estás de acuerdo, <strong>no debés hacer nada</strong>: tu
            espacio seguirá estando visible como siempre.
            <br />
            <br />
            ❌ En caso contrario, podés{" "}
            <strong>desactivar la publicación</strong> desde tu panel y
            automáticamente dejará de mostrarse.
          </p>
        </div>

        {/* Botón */}
        <div style={styles.footer}>
          <button
            style={styles.button}
            onClick={onClose}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#e94300";
              e.currentTarget.style.transform = "scale(1.03)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "#FF4E00";
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            ¡Entendido!
          </button>
        </div>
      </div>
    </div>
  );
};

export default HostFreeNoticeModal;
